// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".regular-price[data-v-466fdc56] .caption{background-color:#636363}.price-row--font-small[data-v-466fdc56] .caption{font-size:10px}.price-row--font-small[data-v-466fdc56] .price{font-size:8px}", ""]);
// Exports
module.exports = exports;
